export const VERSION = '4.3.6';
export const NAME = '@coinbase/wallet-sdk';
//# sourceMappingURL=sdk-info.js.map